'use strict';

// Assigned Dependencies
export function exec () {
	$(document).ready(function() {
		$(window).resize(moveBreadcrumbs);
		moveBreadcrumbs();
		setupBreadcrumbs();
    });
}

function moveBreadcrumbs() {
	var listHeight ='auto', listItemHeight = 'auto';
	var breadcrumbs = $('.breadcrumbs-outer').detach();
	var desktopContainer = $('.breadcrumbs-container__content');
	var mobileContainer = $('.breadcrumbs-container__page-header');
	var isMobile = $(mobileContainer).is(':visible');
	if (isMobile) {
		$(mobileContainer).append(breadcrumbs);
		$('.breadcrumbs-trigger').each(function(){
			listHeight = $('.breadcrumbs-outer').find('.breadcrumbs').outerHeight();
			listItemHeight = $('.breadcrumbs-outer').find('.breadcrumbs > li:last-child').outerHeight();
			toggleBreadcrumbs($(this), true, listHeight, listItemHeight);
		});
	}
	else {
		$(desktopContainer).append(breadcrumbs);
		$('.breadcrumbs-trigger').each(function(){
			listHeight ='auto';
	    	listItemHeight = 'auto';
	    	toggleBreadcrumbs($(this), true, listHeight, listItemHeight);
		});
	}
}

function setupBreadcrumbs() {
	var listHeight ='auto', listItemHeight = 'auto';
	var mobileContainer = $('.breadcrumbs-container__page-header');
	var isMobile = $(mobileContainer).is(':visible');
	if (isMobile) {
		listHeight = $('.breadcrumbs-outer').find('.breadcrumbs').outerHeight();
		listItemHeight = $('.breadcrumbs-outer').find('.breadcrumbs > li:last-child').outerHeight();
	}
	$( document ).on( 'menu-opened-overlay-clicked', function() {
		toggleBreadcrumbs($('.breadcrumbs-trigger'), true,listHeight,listItemHeight);
	});

	$(document).on('hide-main-menu-sub-panels',function(){
		toggleBreadcrumbs($('.breadcrumbs-trigger'), true,listHeight,listItemHeight);
	});

	$('.breadcrumbs-trigger').bind('click', function(e) {
		e.preventDefault();
		$('.breadcrumbs-outer').toggleClass('active');
		toggleBreadcrumbs($(this), !$('.breadcrumbs-outer').hasClass('active'),listHeight,listItemHeight);
	});
}


function toggleBreadcrumbs(element, hide,listHeight,listItemHeight){
	if (!hide) {
		$('.breadcrumb-opened-overlay').addClass('active');
		$(element).closest('.breadcrumbs-inner').height(listHeight);
		$(element).find('.icon--more').hide();
		$(element).find('.icon--less').show();
	}
	else {
		$('.breadcrumb-opened-overlay').removeClass('active');
		$(element).closest('.breadcrumbs-inner').height(listItemHeight);
		$(element).find('.icon--more').show();
		$(element).find('.icon--less').hide();
		$('.breadcrumbs-outer').removeClass('active');
	}
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/breadcrumbs/index.js